import React, { Component } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	cursor: pointer;
	user-select: none;
	padding: 8px 60px;
	border: 2px solid #ffb961;
	margin: auto;
	border-radius: 100px;
	font-size: 16px;
	background-color: #fff;
	svg {
		position: absolute;
		top: 50%;
		right: 20px;
		transform: translateY(-50%);
		fill: #ffb961;
	}
	@keyframes Spinner {
		from {
			rotate: 0deg;
		}
		to {
			rotate: 360deg;
		}
	}
`;

type Props = {
	label: string;
	Icon: JSX.Element;
	onClick: () => void;
	style?: React.CSSProperties;
};

type State = {};

class Button extends Component<Props, State> {
	state = {};

	render() {
		return (
			<Wrapper
				style={{ ...this.props.style }}
				onClick={this.props.onClick}
			>
				{this.props.label}
				{this.props.Icon}
			</Wrapper>
		);
	}
}

export default Button;
